import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useContext, useImperativeHandle, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Fields from './Fields';

const VirtualProductForm = forwardRef(({product, onSaved}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  return (
    <BaseForm
      ref={formRef}
      entity={product}
      type="product"
      fieldsComponent={Fields}
      onSave={(update) => {
        const {trial_length, trial_unit, ...attrs} = update;
        return services.virtualProduct.saveProduct({
          ...attrs,
          trial_length: trial_length ?? null,
          trial_unit: trial_length ? trial_unit : null,
        });
      }}
      onSaved={onSaved}
    />
  );
});

export default VirtualProductForm;
